import { isWebView } from '@busuu/web-view';
import { PRICING_COHORTS, FREE_TRIAL_TYPES } from '@busuu/pricing';

var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
var EXPERIMENT_ORIGINAL = 'A';
var EXPERIMENT_VARIANT = 'B';
var EXPERIMENT_VARIANT_2 = 'C';
var GOAL_CTA_UPDATE = 'GOAL_CTA_UPDATE';
var GRAMMAR_REVIEW_AVAILABLE = 'GRAMMAR_REVIEW_AVAILABLE';
var UNLOCK_CHAPTER = 'UNLOCK_CHAPTER';
var OUTCOME_BASED_DAILY_GOAL = 'OUTCOME_BASED_DAILY_GOAL';
var GOOGLE_AD_MANAGER_ADS = 'GOOGLE_AD_MANAGER_ADS';
var ALWAYS_ON_LESSON_POPUP_EXPERIMENT = 'ALWAYS_ON_LESSON_POPUP_EXPERIMENT';
var OTHER_LEARNING_REASON_EXPERIMENT = 'OTHER_LEARNING_REASON_EXPERIMENT';
var PAYWALL_AFTER_SIXTH_LESSON = 'PAYWALL_AFTER_SIXTH_LESSON';
var Q1_2024_PRICING_EXPERIMENT = 'Q1_2024_PRICING_EXPERIMENT';
var B2B_MANDATORY_ONBOARDING_PLACEMENT_TEST_EXPERIMENT = 'B2B_MANDATORY_ONBOARDING_PLACEMENT_TEST_EXPERIMENT';
var experiments = (_a = {},
    _a[GOAL_CTA_UPDATE] = {
        id: '25853180004',
        variations: (_b = {},
            _b[EXPERIMENT_ORIGINAL] = '25796420594',
            _b[EXPERIMENT_VARIANT] = '25788990743',
            _b),
    },
    _a[GRAMMAR_REVIEW_AVAILABLE] = {
        id: '26018832243',
        variations: (_c = {},
            _c[EXPERIMENT_ORIGINAL] = '26020742400',
            _c[EXPERIMENT_VARIANT] = '26034691780',
            _c),
    },
    _a[UNLOCK_CHAPTER] = {
        id: '26168450129',
        variations: (_d = {},
            _d[EXPERIMENT_ORIGINAL] = '26167620205',
            _d[EXPERIMENT_VARIANT] = '26156220249',
            _d),
    },
    _a[OUTCOME_BASED_DAILY_GOAL] = {
        id: '25979753412',
        variations: (_e = {},
            _e[EXPERIMENT_ORIGINAL] = '25983362860',
            _e[EXPERIMENT_VARIANT] = '26004942707',
            _e),
    },
    _a[GOOGLE_AD_MANAGER_ADS] = {
        id: '26061700388',
        variations: (_f = {},
            _f[EXPERIMENT_ORIGINAL] = '26105270004',
            _f[EXPERIMENT_VARIANT] = '26103110054',
            _f),
    },
    _a[ALWAYS_ON_LESSON_POPUP_EXPERIMENT] = {
        id: '26598280335',
        variations: (_g = {},
            _g[EXPERIMENT_ORIGINAL] = '26603390409',
            _g[EXPERIMENT_VARIANT] = '26607240453',
            _g),
    },
    _a[OTHER_LEARNING_REASON_EXPERIMENT] = {
        id: '26982340816',
        variations: (_h = {},
            _h[EXPERIMENT_ORIGINAL] = '26904810850',
            _h[EXPERIMENT_VARIANT] = '27007760567',
            _h),
    },
    _a[PAYWALL_AFTER_SIXTH_LESSON] = {
        id: '27181060488',
        variations: (_j = {},
            _j[EXPERIMENT_ORIGINAL] = '27162470530',
            _j[EXPERIMENT_VARIANT] = '27243140267',
            _j),
    },
    _a[Q1_2024_PRICING_EXPERIMENT] = {
        id: '27478400595',
        variations: (_k = {},
            _k[EXPERIMENT_ORIGINAL] = '27491610286',
            _k[EXPERIMENT_VARIANT] = '27545990046',
            _k[EXPERIMENT_VARIANT_2] = '27542180042',
            _k),
    },
    _a[B2B_MANDATORY_ONBOARDING_PLACEMENT_TEST_EXPERIMENT] = {
        id: '27503820505',
        variations: (_l = {},
            _l[EXPERIMENT_ORIGINAL] = '27497700534',
            _l[EXPERIMENT_VARIANT] = '27430820849',
            _l),
    },
    _a);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

// In order not to duplicate console.logs, we track this notice flag here
var optimizelyAbsenceNoticeDisplayed = false;
// Experiments running in Optimizely
var runningExperiments = null;
// User data to send to Optimizely
var commonUserData = {};
// Enable debugging logs
var enableLogs = false;
var FILENAME = 'experiments.service.ts';
var setOptimizelyAbsenceNoticeDisplayed = function () {
    if (!optimizelyAbsenceNoticeDisplayed) {
        optimizelyAbsenceNoticeDisplayed = true;
        console.log(FILENAME, 'Optimizely not initialized in the global window.');
    }
};
/**
 * Returns true if Optimizely is loaded in the window object
 * @returns {boolean}
 */
var isOptimizelyLoaded = function () {
    var optimizelyLoaded = Boolean(window.optimizely && Object.keys(window.optimizely).includes('get'));
    if (!optimizelyLoaded) {
        setOptimizelyAbsenceNoticeDisplayed();
    }
    return optimizelyLoaded;
};
/**
 * Returns an object with all the current
 * running experiments.
 * NB: We avoid multiple invokes to getExperimentStates() method
 * in Optimizely as it has costs performance (see documentation).
 * We can bypass this by using force param only when necessary e.g.
 * Experiments that rely on user data being sent to Optimizely
 *  to evaluate audience conditions
 */
var getRunningExperiments = function (force) {
    if (!isOptimizelyLoaded()) {
        return {};
    }
    if (runningExperiments && !force) {
        return runningExperiments;
    }
    runningExperiments = window.optimizely.get('state').getExperimentStates({
        isActive: true,
    });
    return runningExperiments;
};
/**
 *  Returns active experiments and variants ids as :
 *  {
 *   'experiment1Id': 'variantId',
 *   'experiment2Id': 'variant2Id'
 *  }
 */
var getExperimentsData = function () {
    if (!isOptimizelyLoaded()) {
        return {};
    }
    var state = window.optimizely.get('state');
    var experiments = state.getExperimentStates();
    return Object.entries(experiments).reduce(function (result, _a) {
        var _b;
        var experimentId = _a[0], experimentEntry = _a[1];
        if (experimentEntry.isActive && ((_b = experimentEntry.variation) === null || _b === void 0 ? void 0 : _b.id)) {
            result[experimentId] = experimentEntry.variation.id;
        }
        return result;
    }, {});
};
/**
 * Returns data from a given experiment.
 * @param {string} experimentId - experiment id
 * @returns {object | null}
 */
var getRunningExperiment = function (experimentId) {
    if (!runningExperiments)
        getRunningExperiments();
    var experiment = runningExperiments === null || runningExperiments === void 0 ? void 0 : runningExperiments[experimentId];
    return experiment || null;
};
/**
 * Function that returns a boolean based on whether a user is inside 1 or various experiment buckets in Optimizely
 * @param {string} experimentName - Optimizely experiment name
 * @param {string | string[]} experimentBuckets - Optimizely experiment bucket or a list of experiment buckets
 * @param {boolean} force - Force fetch latest experiment data
 * @returns boolean
 */
var isInOptimizelyExperiment = function (experimentName, experimentBuckets, force) {
    if (force)
        getRunningExperiments(force);
    var currentExperimentData = experiments[experimentName] || null;
    if (!currentExperimentData) {
        return false;
    }
    var runningExperiment = getRunningExperiment(currentExperimentData.id);
    if (!runningExperiment) {
        return false;
    }
    var runningExperimentBucketId = runningExperiment.variation.id;
    if (typeof experimentBuckets === 'string') {
        return runningExperimentBucketId === currentExperimentData.variations[experimentBuckets];
    }
    var isInAnyBucket = experimentBuckets.some(function (bucket) { return runningExperimentBucketId === currentExperimentData.variations[bucket]; });
    return isInAnyBucket;
};
/**
 * Update Optimizely data, it's called on every route change to check
 * if the route is part of an experiment. Only used in Webapp due to high traffic
 * to reduce the usage of Optimizely quota
 */
var refreshOptimizelyData = function () {
    if (!isOptimizelyLoaded()) {
        return;
    }
    window.optimizely.push({
        type: 'activate',
    });
};
/**
 * Return Optimizely Visitor Id
 * @returns {string | null} - ex: "oeu1703074814658r0.3177618151798349"
 */
var getOptimizelyVisitorId = function () {
    if (!isOptimizelyLoaded()) {
        return null;
    }
    return window.optimizely.get('visitor').visitorId;
};
var isLocalEnvironment = function () {
    var location = window.location;
    if (!location) {
        return false;
    }
    var hostname = location.hostname;
    var locals = ['localhost', 'local.internal.busuu.com', 'local-hp.internal.busuu.com'];
    return Boolean(locals.indexOf(hostname) !== -1);
};
var preventTracking = function (eventName, data) {
    if (data === void 0) { data = {}; }
    if (enableLogs) {
        console.log("[" + FILENAME + "] TRACKING OPTIMIZELY: " + eventName + ", " + JSON.stringify(data));
        return false;
    }
    return isLocalEnvironment();
};
/**
 * Update country_code custom attribute for user in Optimizely
 */
var updateOptimizelyUserCountry = function (_a) {
    var countryCode = _a.countryCode;
    if (!isOptimizelyLoaded()) {
        return;
    }
    /**
     * Use this API to record the user's values for any number
     * of dimensions or custom attributes.
     * https://developers.optimizely.com/x/solutions/javascript/reference/index.html#function_setuser
     */
    window.optimizely.push({
        type: 'user',
        attributes: {
            country_code: countryCode,
        },
    });
    refreshOptimizelyData();
};
/**
 * Store extra data for Optimizely events
 */
var initOptimizelyUserInfo = function (user, setLogs) {
    var _a, _b, _c, _d, _e, _f;
    if (!isOptimizelyLoaded()) {
        console.log('Optimizely was not initiated correctly.');
        return;
    }
    enableLogs = setLogs || false;
    commonUserData = __assign(__assign({}, commonUserData), { uid: (_a = user === null || user === void 0 ? void 0 : user.uid) !== null && _a !== void 0 ? _a : null, platform: 'Web', country: (_b = user === null || user === void 0 ? void 0 : user.country) !== null && _b !== void 0 ? _b : '', country_code: (_c = user === null || user === void 0 ? void 0 : user.country_code) !== null && _c !== void 0 ? _c : '', role: (user === null || user === void 0 ? void 0 : user.is_premium) ? 'premium' : 'free', language_learnt: (_d = user === null || user === void 0 ? void 0 : user.languages.learning_default) !== null && _d !== void 0 ? _d : '', interface_language: (_e = user === null || user === void 0 ? void 0 : user.languages.interface) !== null && _e !== void 0 ? _e : '', created_timestamp: (_f = user === null || user === void 0 ? void 0 : user.created) !== null && _f !== void 0 ? _f : 0 });
    // If user is a B2B user, add the institution details here
    if (user === null || user === void 0 ? void 0 : user.institution) {
        commonUserData.role = 'b2b';
        commonUserData.institution_role = user.institution.institution_role || null;
        commonUserData.institution_id = user.institution.institution_id || null;
    }
    window.optimizely.push({
        type: 'user',
        attributes: commonUserData,
    });
    refreshOptimizelyData();
};

/**
 * Goal CTA update
 * Show different copy for Goal CTA in onboarding
 */
var isInGoalCTAUpdateExperiment = function () {
    return isInOptimizelyExperiment(GOAL_CTA_UPDATE, EXPERIMENT_VARIANT);
};
/**
 * Grammar Review Available
 * Returns true if the user is in the bucket that has GR available.
 * This experiment is just for a controlled deployment of functionality.
 * As soon as it proves stable, the experiment will be removed and GR will be available to 100% of users.
 */
var isInGrammarReviewAvailableExperiment = function () {
    return isInOptimizelyExperiment(GRAMMAR_REVIEW_AVAILABLE, EXPERIMENT_VARIANT);
};
/**
 * Unlock chapter
 * Show a bottom sheet prompting to unlock the selected chapter
 */
var isInUnlockChapterExperiment = function () {
    return isInOptimizelyExperiment(UNLOCK_CHAPTER, EXPERIMENT_VARIANT);
};
/**
 * Outcome based daily goal
 * Show a tailored popup for daily goal
 */
var isInOutcomeBasedDailyGoalExperiment = function () {
    return isInOptimizelyExperiment(OUTCOME_BASED_DAILY_GOAL, EXPERIMENT_VARIANT);
};
/**
 * Change providers to Google
 */
var isInGoogleAdManagerExp = function () {
    return isInOptimizelyExperiment(GOOGLE_AD_MANAGER_ADS, EXPERIMENT_VARIANT);
};
/**
 * Modular paywall experiment
 * Show a new paywall design
 */
var isInAlwaysOnLessonPopup = function () {
    return isInOptimizelyExperiment(ALWAYS_ON_LESSON_POPUP_EXPERIMENT, EXPERIMENT_VARIANT);
};
/**
 * Add a new "Other" reason to Onboarding Learning Reasons step
 */
var isInOtherLearningReasonExperiment = function () {
    return isInOptimizelyExperiment(OTHER_LEARNING_REASON_EXPERIMENT, EXPERIMENT_VARIANT);
};
/**
 * Adds a new paywall after the 6th lesson
 */
var isInPaywallAfterSixthLessonExperiment = function () {
    return isInOptimizelyExperiment(PAYWALL_AFTER_SIXTH_LESSON, EXPERIMENT_VARIANT);
};
/**
 * Set as a Mandatory Onboarding Placement Test for B2B users
 */
var isInB2BMandatoryOnboardingPlacementTestExperiment = function () {
    return isInOptimizelyExperiment(B2B_MANDATORY_ONBOARDING_PLACEMENT_TEST_EXPERIMENT, EXPERIMENT_VARIANT);
};

// Original pricing cohorts
var STANDARD = 'STANDARD';
var FREE_TRIAL_REFERRAL = 'FREE_TRIAL_REFERRAL';
var FREE_TRIAL_BASIC = 'FREE_TRIAL_BASIC';
// Skeleton for pricing experiment cohorts
var PRICING_EXPERIMENT_COHORTS = {
    Q1_2024_VARIANT_A_STANDARD: 'sub_standard_q1_2024_variant_1',
    Q1_2024_VARIANT_A_FREE_TRIAL_BASIC: 'free_users_q1_2024_variant_1',
    Q1_2024_VARIANT_A_FREE_TRIAL_REFERRAL: 'free_trial_web_v1_q1_2024_variant_1',
    Q1_2024_VARIANT_B_STANDARD: 'sub_standard_q1_2024_variant_2',
    Q1_2024_VARIANT_B_FREE_TRIAL_BASIC: 'free_users_q1_2024_variant_2',
    Q1_2024_VARIANT_B_FREE_TRIAL_REFERRAL: 'free_trial_web_v1_q1_2024_variant_2',
    Q1_2024_VARIANT_C_STANDARD: 'sub_standard_q1_2024_variant_3',
    Q1_2024_VARIANT_C_FREE_TRIAL_BASIC: 'free_users_q1_2024_variant_3',
    Q1_2024_VARIANT_C_FREE_TRIAL_REFERRAL: 'free_trial_web_v1_q1_2024_variant_3',
};
// Pricing experiment countries list
var PRICING_EXPERIMENT_COUNTRIES_LIST = ['US', 'DE', 'PL', 'GB', 'TR', 'BR', 'MX', 'ES', 'CH'];

// Utils
var isInQ1PricingExperimentCountry = function (countryCode) {
    return PRICING_EXPERIMENT_COUNTRIES_LIST.includes(countryCode);
};
// TODO only use Optimizely audience set up instead of in-code
var isInQ1PricingExperiment = function (user) {
    if (!user)
        return false;
    var isNotPremium = !user.is_premium;
    var isInExpCountry = isInQ1PricingExperimentCountry(user.country_code);
    var isNotInWebView = !isWebView();
    return isNotPremium && isInExpCountry && isNotInWebView;
};
var getQ1PricingExperimentCohort = function (cohort) {
    var _a, _b, _c;
    var experimentId = (_a = experiments[Q1_2024_PRICING_EXPERIMENT]) === null || _a === void 0 ? void 0 : _a.id;
    if (experimentId) {
        var experimentVariant = (_b = getRunningExperiment(experimentId)) === null || _b === void 0 ? void 0 : _b.variation.name;
        if (experimentVariant) {
            var key = "Q1_2024_VARIANT_" + experimentVariant + "_" + cohort;
            return (_c = PRICING_EXPERIMENT_COHORTS[key]) !== null && _c !== void 0 ? _c : PRICING_COHORTS[cohort];
        }
    }
    return PRICING_COHORTS[cohort];
};
/**
 * Returns a Standard pricing cohort based on whether the user is inside pricing experiment(s)
 * @returns {string}
 */
var getStandardPricingCohort = function (user) {
    if (!user || !isInQ1PricingExperiment(user))
        return PRICING_COHORTS.STANDARD;
    return getQ1PricingExperimentCohort(STANDARD);
};
/**
 * Returns a Free Trial Referral pricing cohort based on whether the user is inside pricing experiment(s)
 * @returns {string}
 */
var getFTReferralPricingCohort = function (user) {
    if (!user || !isInQ1PricingExperiment(user))
        return PRICING_COHORTS.FREE_TRIAL_REFERRAL;
    return getQ1PricingExperimentCohort(FREE_TRIAL_REFERRAL);
};
/**
 * Returns a Free Trial Basic pricing cohort based on whether the user is inside pricing experiment(s)
 * @returns {string}
 */
var getFTBasicPricingCohort = function (user) {
    if (!user || !isInQ1PricingExperiment(user))
        return PRICING_COHORTS.FREE_TRIAL_BASIC;
    return getQ1PricingExperimentCohort(FREE_TRIAL_BASIC);
};
/**
 * Returns a Free Trial pricing cohort based on free trial type
 * @param {string} trialType - free trial type
 * @returns {string}
 */
var getFreeTrialPricingCohort = function (trialType, user) {
    if (trialType === FREE_TRIAL_TYPES.REFERRAL) {
        return getFTReferralPricingCohort(user);
    }
    return getFTBasicPricingCohort(user);
};

export { ALWAYS_ON_LESSON_POPUP_EXPERIMENT, B2B_MANDATORY_ONBOARDING_PLACEMENT_TEST_EXPERIMENT, EXPERIMENT_ORIGINAL, EXPERIMENT_VARIANT, EXPERIMENT_VARIANT_2, FREE_TRIAL_BASIC, FREE_TRIAL_REFERRAL, GOAL_CTA_UPDATE, GOOGLE_AD_MANAGER_ADS, GRAMMAR_REVIEW_AVAILABLE, OTHER_LEARNING_REASON_EXPERIMENT, OUTCOME_BASED_DAILY_GOAL, PAYWALL_AFTER_SIXTH_LESSON, PRICING_EXPERIMENT_COHORTS, PRICING_EXPERIMENT_COUNTRIES_LIST, Q1_2024_PRICING_EXPERIMENT, STANDARD, UNLOCK_CHAPTER, commonUserData, enableLogs, experiments, getExperimentsData, getFTBasicPricingCohort, getFTReferralPricingCohort, getFreeTrialPricingCohort, getOptimizelyVisitorId, getRunningExperiment, getRunningExperiments, getStandardPricingCohort, initOptimizelyUserInfo, isInAlwaysOnLessonPopup, isInB2BMandatoryOnboardingPlacementTestExperiment, isInGoalCTAUpdateExperiment, isInGoogleAdManagerExp, isInGrammarReviewAvailableExperiment, isInOptimizelyExperiment, isInOtherLearningReasonExperiment, isInOutcomeBasedDailyGoalExperiment, isInPaywallAfterSixthLessonExperiment, isInQ1PricingExperiment, isInUnlockChapterExperiment, isOptimizelyLoaded, preventTracking, refreshOptimizelyData, runningExperiments, updateOptimizelyUserCountry };
//# sourceMappingURL=index.esm.js.map
